import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { pt } from "date-fns/locale/pt";

interface Range {
	startDate: Date | null;
	endDate: Date | null;
}

interface DateRangePickerProps {
	onChange: (range: Range) => void;
	defaultDate?: Range;
}

function getStartOfDay(date: Date): Date {
	return new Date(
		date.getFullYear(),
		date.getMonth(),
		date.getDate(),
		0,
		0,
		0,
		0,
	);
}

function getEndOfDay(date: Date): Date {
	return new Date(
		date.getFullYear(),
		date.getMonth(),
		date.getDate(),
		23,
		59,
		59,
		999,
	);
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
	onChange,
	defaultDate,
}) => {
	const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
		defaultDate?.startDate || null,
		defaultDate?.endDate || null,
	]);
	const [startDate, endDate] = dateRange;

	const handleDateChange = (dates: [Date | null, Date | null]) => {
		setDateRange(dates);
		const [start, end] = dates;
		if (start && end) {
			onChange({ startDate: start, endDate: end });
		}
	};

	const setShortcut = (shortcut: "last3Days" | "yesterday" | "today") => {
		const now = new Date();
		let start: Date, end: Date;

		if (shortcut === "last3Days") {
			start = getStartOfDay(
				new Date(now.getFullYear(), now.getMonth(), now.getDate() - 3),
			);
			end = getEndOfDay(
				new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1),
			);
		} else if (shortcut === "yesterday") {
			start = getStartOfDay(
				new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1),
			);
			end = getEndOfDay(
				new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1),
			);
		} else {
			start = getStartOfDay(now);
			end = getEndOfDay(now);
		}
		setDateRange([start, end]);
		onChange({ startDate: start, endDate: end });
	};

	return (
		<div className="relative w-full py-2">
			<div className="mb-2 flex gap-2">
				<button
					className="bg-primary text-white px-2 py-1 rounded bg-none"
					onClick={() => setShortcut("last3Days")}
				>
					Últimos 3 dias
				</button>
				<button
					className="bg-primary text-white px-2 py-1 rounded bg-none"
					onClick={() => setShortcut("yesterday")}
				>
					Ontem
				</button>
				<button
					className="bg-primary text-white px-2 py-1 rounded bg-none"
					onClick={() => setShortcut("today")}
				>
					Hoje
				</button>
			</div>
			<DatePicker
				onChange={handleDateChange}
				startDate={startDate}
				endDate={endDate}
				selectsRange
				dateFormat="dd/MM/yyyy"
				locale={pt}
				minDate={new Date(2024, 0, 1)}
				maxDate={new Date()}
				placeholderText="Selecione o Intervalo de Datas"
				className="border rounded-md py-2 text-left w-full"
			/>
		</div>
	);
};

export default DateRangePicker;
